import React, { useMemo } from 'react';

import { getDateFormats } from 'utils/date';

export const LocaleContext = React.createContext();

export const LocaleProvider = ({ dateFormat, timeFormat, weekStart, language, children }) => {
    const locale = useMemo(() => ({
        dateTimeFormats: getDateFormats(timeFormat || '12h')[dateFormat || 'mm/dd/yyyy'],
        weekStart: weekStart || 0,
        timeFormat,
        language,
        getLocale: () => language
    }), [dateFormat, timeFormat, weekStart]);

    return (
        <LocaleContext.Provider value={locale}>
            { children }
        </LocaleContext.Provider>
    )
};
